import React, { useState, useEffect } from "react";

import { ScrollToTopButton } from "./ToTopButton.elements";

const ScrollToTop = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    const element = document.getElementById("filters");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <ScrollToTopButton onClick={scrollToTop} show={showButton}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.5669 17.6831L13.4059 12.5222C15.6598 9.82114 15.522 5.79931 12.9864 3.26365C11.6439 1.92121 9.88446 1.25 8.12499 1.25C6.36553 1.25 4.60606 1.92121 3.26365 3.26365C0.578785 5.94849 0.578785 10.3015 3.26365 12.9863C4.60606 14.3288 6.36553 15 8.12499 15C9.68892 15 11.2511 14.4666 12.5221 13.4059L17.6831 18.5669C17.8052 18.689 17.9651 18.75 18.125 18.75C18.2849 18.75 18.4448 18.689 18.5669 18.5669C18.811 18.323 18.811 17.927 18.5669 17.6831ZM4.14754 12.1025C3.08509 11.0401 2.49999 9.62748 2.49999 8.125C2.49999 6.62252 3.08509 5.20994 4.14754 4.14752C5.20995 3.0851 6.62251 2.5 8.12499 2.5C9.6275 2.5 11.0401 3.0851 12.1025 4.14752C13.1649 5.20994 13.75 6.62252 13.75 8.125C13.75 9.62748 13.1649 11.0401 12.1025 12.1025C11.0401 13.1649 9.6275 13.75 8.12499 13.75C6.62251 13.75 5.20995 13.1649 4.14754 12.1025Z"
          fill="white"
        />
      </svg>
    </ScrollToTopButton>
  );
};

export default ScrollToTop;
